import request from './request';

export type ChatRetentionPeriod = '7' | '30' | '60' | '90' | 'permanent';

export interface AppSettings {
    chatRetention: ChatRetentionPeriod;
    isAiTakeoverGlobal: boolean;
}

// Fetch settings from backend
export const getSettingsApi = async (): Promise<AppSettings> => {
    const response = await request.get('/api/settings');
    // Backend might return enum values (e.g. "7_days"), frontend expects "7"
    // Ensure mapping if necessary. Assuming backend matches for now or returns simple values.
    return {
        chatRetention: response.data.chatRetention,
        isAiTakeoverGlobal: response.data.isAiTakeoverGlobal,
    };
};

// Update settings
export const updateSettingsApi = async (settings: Partial<AppSettings>): Promise<AppSettings> => {
    const response = await request.put('/api/settings', {
        chatRetention: settings.chatRetention,
        isAiTakeoverGlobal: settings.isAiTakeoverGlobal,
    });
    return {
        chatRetention: response.data.chatRetention,
        isAiTakeoverGlobal: response.data.isAiTakeoverGlobal,
    };
};
